module.exports = __webpack_public_path__ + "static/media/clock.c16db72c.svg";